import React from "react";
import { Stack, Text } from "@fluentui/react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ICatalystCompleteInsights } from "../../../../interfaces/Catalyst.interfaces";

export interface CatalystCompleteInsightsTableProps {
  data?: ICatalystCompleteInsights[];
  isLoading?: boolean;
}

const columns: GridColDef[] = [
  {
    field: "tenantId",
    headerName: "Tenant ID",
    width: 250,
    minWidth: 220,
  },
  {
    field: "competitorName",
    headerName: "Competitor",
    flex: 0.85,
    minWidth: 105,
  },
  {
    field: "products",
    headerName: "Products",
    flex: 0.85,
    minWidth: 105,
  },
];

export const CatalystCompleteInsightsTable: React.FC<CatalystCompleteInsightsTableProps> = ({
  data,
  isLoading = false,
}) => {
  const rows = (data || []).map((item, index) => ({
    id: index,
    tenantId: item.tenantId ?? "-",
    competitorName: item.competitorName ?? "-",
    products: item.products ?? "-",
  }));

  return (
    <Stack tokens={{ childrenGap: 8 }} styles={{ root: { flex: 1 } }}>
      <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
        Compete Insights
      </Text>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        autoHeight
        rowHeight={36}
        columnHeaderHeight={56}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10]}
        initialState={{
          pagination: { paginationModel: { pageSize: 5 } },
        }}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton" as any,
            noRowsVariant: "skeleton" as any,
          },
        }}
        sx={{
          border: "none",
          "& .MuiDataGrid-columnHeaders": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            paddingLeft: 2,
            paddingRight: 2,
          },
          "& .MuiDataGrid-row:hover": { backgroundColor: "#F3F2F1" },
        }}
      />
    </Stack>
  );
};
